import { Spin } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory, Router } from 'react-router'
import { getMerchantInfo } from '@merchant-backend/util'
import './configuration'
import { GlobalContext } from './globalContext'
import routerConfig, { otherRoutes } from './routerConfig'
import Store from './store'
import Tracker from '@components/Tracker'

// 是否是支付页面
const isJavaPay = () => window.location.hash.indexOf('cashierNew') > -1
const isAnnualMerchant = () =>
  window.location.hash.indexOf('annualMerchantShow') > -1
const isNormalPay = () => window.location.hash.indexOf('#/cashier') > -1

function Loading() {
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Spin className="center" size="large" />
    </div>
  )
}

function isWithInSystem(WrappedComponent) {
  if (isJavaPay() || isAnnualMerchant()) {
    return () => <Router history={hashHistory} routes={otherRoutes} />
  }

  return class extends Component {
    render() {
      return <WrappedComponent {...this.props} />
    }
  }
}

@observer
class App extends Component {
  constructor(props) {
    super(props)
    this.isOtherNeedAuth = isNormalPay()
    this.store = new Store()
  }

  tracker = Tracker.createTracker({
    appName: 'web_merchantBackend:local_merchant_react',
    getUid: () => String(getMerchantInfo().merchant_id || -1),
    logEnable: true, // 是否开启日志（建议生产环境关闭日志）
    // eslint-disable-next-line
    env: __ENV__ === 'publish' ? 'publish' : 'pre' // 生产环境需要使用  publish
  })

  getAccess = (hasGetMerchantInfo, storesIsCertified) => {
    return hasGetMerchantInfo && storesIsCertified
  }

  render() {
    const {
      hasGetMerchantInfo,
      accessControlStore: { storesIsCertified }
    } = this.store

    const hasAccess = this.getAccess(hasGetMerchantInfo, storesIsCertified)

    return (
      <Tracker.TrackerProvider tracker={this.tracker}>
        <GlobalContext.Provider value={this.store}>
          {hasAccess ? (
            <Router history={hashHistory} routes={routerConfig} />
          ) : (
            <Loading />
          )}
        </GlobalContext.Provider>
      </Tracker.TrackerProvider>
    )
  }
}

export default isWithInSystem(App)
